/**
 * CMS sahifasi (`/pages/:slug`) — portal menyusidagi «Ichki sahifa» bandlari shu yerga
 * olib keladi (ЧТЗ 4.2.11.1). Matn superadmin panelida WYSIWYG muharrirda yoziladi,
 * ko'rsatishdan oldin oq ro'yxat bo'yicha tozalanadi.
 */
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { portalApi } from "@/shared/api/endpoints";
import type { PortalPage } from "@/shared/api/types";
import { useI18n } from "@/shared/i18n";
import { PublicLayout } from "@/shared/layouts/PublicLayout";
import { sanitizeHtml } from "@/shared/lib/sanitize";
import { Icon } from "@/shared/ui/Icon";

export function PublicPage() {
  const { slug = "" } = useParams();
  const { lang } = useI18n();
  const [page, setPage] = useState<PortalPage | null>(null);
  const [state, setState] = useState<"loading" | "ready" | "missing">("loading");

  useEffect(() => {
    let cancelled = false;
    setState("loading");
    portalApi
      .page(slug, lang)
      .then((data) => {
        if (cancelled) return;
        setPage(data);
        setState("ready");
        document.title = `${data.title} — Smart Forestry`;
      })
      .catch(() => {
        if (!cancelled) setState("missing");
      });
    return () => {
      cancelled = true;
    };
  }, [slug, lang]);

  const body = useMemo(() => sanitizeHtml(page?.body ?? ""), [page?.body]);

  return (
    <PublicLayout>
      <section className="section">
        <div className="container cms-page">
          <p>
            <Link className="btn btn-ghost btn-sm" to="/">
              <Icon name="chevronRight" size={14} className="flip" />
              Bosh sahifa
            </Link>
          </p>
          {state === "loading" ? <p className="muted">Yuklanmoqda…</p> : null}
          {state === "missing" ? (
            <div className="panel-state is-error" role="status">
              <Icon name="alert" size={18} />
              <p>
                <b>Sahifa topilmadi</b>
                <span>Bu manzil mavjud emas yoki hali chop etilmagan.</span>
              </p>
            </div>
          ) : null}
          {state === "ready" && page ? (
            <article>
              <h1>{page.title}</h1>
              {page.summary ? <p className="section-lead">{page.summary}</p> : null}
              <div className="rich-text" dangerouslySetInnerHTML={{ __html: body }} />
            </article>
          ) : null}
        </div>
      </section>
    </PublicLayout>
  );
}
